import { FC } from 'react'
import { Button as AntButton, Modal } from 'antd'
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  onConfirm: () => void;
  titleText: string;
  amount: string;
  confirmText: string;
  cancelText?: string;
  className?: string;
  width?: number;
}

const PartialRefundConfirmModal: FC<IProps> = ({
  visible,
  setVisible,
  onConfirm,
  titleText,
  amount,
  confirmText,
  cancelText,
  className = '',
  width = 400,
}) => {
  const { t } = useTranslation();

  const getFooter = () => {
    if (cancelText) {
      return [
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onConfirm}
          >
            {confirmText}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {cancelText}
          </AntButton>
        </div>
      ]
    } else {
      return [
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onConfirm}
          >
            {confirmText}
          </AntButton>
        </div>
      ]
    }
  }

  return (
    <Modal
      title={titleText}
      open={visible}
      onCancel={() => setVisible(false)}
      width={width}
      footer={getFooter()}
      style={{top:'150px'}}
    >
      <div className={className?className:'flex justify-content-center'} >
        <div><h3 className='sub-title'>{t('sms.send.text4')}<span style={{color:'red'}}>{' ' + amount}</span>{t('business.coupon.column9') + ' '+ t('class.class.text24')}</h3></div>
      </div>
    </Modal>
  );
}

export default PartialRefundConfirmModal;
